// Legacy clients used "None"; the new API uses NONE/UNKNOWN for events
// without a known experience. These are not additional experiences.
export const knownExperienceId = (value) => {
  if (typeof value !== "string") return "";
  const id = value.trim();
  return !id || ["NONE", "UNKNOWN"].includes(id.toUpperCase()) ? "" : id;
};

export const sessionExperienceIds = (events) => [...new Set(
  (Array.isArray(events) ? events : []).map(event => knownExperienceId(event?.experienceId)).filter(Boolean)
)];
